// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"967":"7f80ddfa","1998":"1a12928e"}[chunkId] + ".chunk.css";
};